import './styles/index.scss';

// W2T symbol, traced from assets/W2T_LOGO_symbol.png (184x160): both shapes are open paths so the
// crossings keep the logo's weave (triangle drawn over the ring top-left, gap in the triangle where
// the ring passes at the bottom).
// pathLength=100 lets the stylesheet draw/undraw them with a plain dash animation.
const Loader = () => {
    return <div className="loader_container" role="status" aria-label="Loading">
        <svg className="loader_logo" data-testid="loader-logo" viewBox="0 0 184 160" aria-hidden="true" focusable="false">
            <path
                className="loader_ring"
                d="M49.4 34.4 A72.6 72.6 0 1 1 42 45.2"
                pathLength="100"
            />
            <path
                className="loader_mark"
                d="M61.1 117.6 L124 81 L6.5 12.5 L6.5 149.5 L41.2 129.3"
                pathLength="100"
            />
        </svg>
    </div>
}

export default Loader
